import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import EL, { HTMLELEMENT } from '../../../EL/EL.js';
import LIST from '../../../DOM/LIST/LIST.js';
import DD from '../../../DOM/LIST/dl/dd/DD.js';
import DT from '../../../DOM/LIST/dl/dt/DT.js';
import { LISTTYPES } from '../../../../enums/LISTTYPES.js';
// Model Structure
export const dlAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['style']
]);
export const dlData = makeDataStruct([
    ['children', []],
    ['type', LISTTYPES.DL]
]);
export const dlModel = makeStruct([
    ['attributes', dlAttr],
    ['data', dlData]
]);
// Simplified Model
export function dl(className, style) {
    return dlModel(dlAttr(className, style), dlData());
}
/** A Description List (DL) acts like a Dictionary with terms and descriptions */
export default class DL extends LIST {
    constructor(node, model) {
        super(node, HTMLELEMENT.DL, model);
    }
    /** Construct a Description Term (DT) and append to this element's children */
    addDT(model) {
        return this.addChild(new DT(this, model));
    }
    /** Construct a Description Term Definition (DD) and append to this element's children */
    addDD(model) {
        return this.addChild(new DD(this, model));
    }
}
export { DD, DL, DT, EL, LIST };
